export const LOCALES = [
  { slug: 'en', flag: '🇬🇧', name: 'English' },
  { slug: 'nl', flag: '🇳🇱', name: 'Nederlands' },
];
